import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { ApiConfig } from '../../types/apiConfig';

const initialState: ApiConfig = {
  apiRoot: '',
  apiAddressService: {
    apiRoot: '',
  },
  fusionAuth: {
    domain: '',
    clientId: '',
  },
  brandGroupUrl: '',
  ims: {
    apiRoot: '',
    fusionAuthVersion: '',
  },
  srs: {
    apiRoot: '',
    invitationRoot: '',
  },
};

const apiConfigSlice = createSlice({
  name: 'apiConfig',
  initialState,
  reducers: {
    loadConfig: (state, action: PayloadAction<ApiConfig>) => {
      return action.payload;
    },
  },
});

export const apiConfigSelector = (state: RootState) => state.apiConfig;
export const { loadConfig } = apiConfigSlice.actions;
export default apiConfigSlice.reducer;
